import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button, Row, Col, Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import { object, string } from "yup"
import PhoneInput from 'react-phone-input-2';
// const { useFormik } = React.lazy(() => import('formik'))
// const { object, string } = React.lazy(() => import('yup'))
import * as Yup from 'yup';

const WhitepaperForm = props => {

  const { buttonLabel = "Download" } = props;


  const [curCity, setCity] = useState()
  const [curCountry, setCountry] = useState()
  const [curRegion, setRegion] = useState()
  const [curZip, setZip] = useState()
  const [successMsg, setsuccessMsg] = useState('')
  const [disable, setDisable] = React.useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const personalized_consultation = props.personalized_consultation
  const discuss_detail = props.discuss_detail
  const key = props.form_key
  const form_name = props.form_name
  const company_id = '60e2f262bae0d2cc386c1de4'
  const source = '60e4086c46dcd0d0eecebe8d'
  const pipeline = '5e009a3150476053816421e9'
  const apikey = '663ca52af9a52312606cbe56'
  const publickey = 'dfbc44f68977568186f53347b847953d100f92c3'
  const signature = 'a98012fbee01467f8bada975ea6358cce239e27f'
  const address = {
    countryCode: curCountry,
    regionName: curRegion,
    city: curCity,
    zip: curZip
  }
  const userCountry = address.countryCode?.toLowerCase()

  const formUrl = typeof window !== 'undefined' ? window.location.href : null
  const previousUrl = typeof window !== 'undefined' ? sessionStorage.getItem('previous_url') : null;


  useEffect(() => {
    axios.get('https://ipinfo.io/json').then(result => {
      setCountry(result.data['country'])
      setRegion(result.data['region'])
      setZip(result.data['postal'])
      setCity(result.data['city'])
    })
  }, [])

  const validationSchema = object().shape({
    full_name: string()
      .required('name is required')
      .matches(/^[aA-zZ\s]+$/, 'Name is invalid'),
    phone_no: string()
      .required('Mobile number is required')
      .min(4, 'Mobile number is invalid'),
    // last_name: string()
    //   .required('Last name is required')
    //   .matches(/^[aA-zZ\s]+$/, 'Name is invalid'),
    company_name: string().required('Company name is required'),
    // email: string().required('Email is required').email('Email is invalid'),
    email: Yup
                .string()
                .required('Email is required')
                .test(
                    'valid-email',
                    'Email is invalid',
                    (value) =>
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|in|co)$/.test(value)
                )
                .test(
                    'no-gmail',
                    'Gmail addresses are not allowed',
                    (value) => !!value && !value.toLowerCase().includes('@gmail.com')
                ),
    personalized_consultation: props.personalized_consultation ? string().required('Personalized consultation is required') : null,
    discuss_detail: props.discuss_detail ? string().required('Personalized consultation is required') : null,
  })

  const formikLogin = useFormik({
    initialValues: {
      full_name: '',
      // last_name: '',
      phone_no: '',
      company_name: '',
      email: '',
      personalized_consultation: '',
      discuss_detail: '',
      form_name: props.form_name,
      pdf_url: props.pdf_url
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {


      const full_name = values.full_name

      const additional_info = {
        url: formUrl,
        form_name: form_name
      }
      const hubpost_properties = {
        // industry: values.industry,
        // product_interested_in: values.reason,
        // license_status: values.license,
        source_url: formUrl,
        preivous_url: previousUrl || "No",
      }
      setDisable(true)
      setIsLoading(true)

      try {
        // let result = await fetch(
        //   'https://q0j7z0lfs5.execute-api.us-west-2.amazonaws.com/lambda-create-deal',
        //   {
        //     method: 'POST',
        //     body: JSON.stringify({
        //       full_name,
        //       email: values.email,
        //       company_name: values.company_name,
        //       pdf_url,
        //       key,
        //       form_name,
        //       address,
        //       additional_info,
        //       company_id,
        //       source,
        //       pipeline,
        //       apikey,
        //       publickey,
        //       signature
        //     }),
        //     headers: { 'Content-Type': 'application/json' }
        //   }
        // )

        let result_pms_crm_lead = await fetch(
          'https://9cdbp7k459.execute-api.us-west-2.amazonaws.com/default/pms_crm_lead',
          {
            method: 'POST',
            body: JSON.stringify({
              full_name,
              phone_no: values.phone_no,
              email: values.email,
              company_name: values.company_name,
              personalized_consultation: values.personalized_consultation,
              discuss_detail: values.discuss_detail,
              description: values.form_name,
              pdf_url: values.pdf_url,
              key,
              form_name: values.form_name,
              address,
              additional_info,
              company_id,
              source,
              pipeline,
              hubpost_properties,
              apikey,
              publickey,
              signature
            }),
            headers: { 'Content-Type': 'application/json' }
          }
        )

        let result_hubspot_lead = await fetch(
          'https://qtjs8w6uzg.execute-api.us-west-2.amazonaws.com/default/hubspot_lead',
          {
            method: 'POST',
            body: JSON.stringify({
              full_name,
              phone_no: values.phone_no,
              email: values.email,
              company_name: values.company_name,
              description: values.form_name,
              personalized_consultation: values.personalized_consultation,
              discuss_detail: values.discuss_detail,
              pdf_url: values.pdf_url,
              key,
              form_name: values.form_name,
              address,
              additional_info,
              company_id,
              source,
              pipeline,
              hubpost_properties,
              apikey,
              publickey,
              signature
            }),
            headers: { 'Content-Type': 'application/json' }
          }
        )

        result_pms_crm_lead = await result_pms_crm_lead.json()
        result_hubspot_lead = await result_hubspot_lead.json()

        if (result_pms_crm_lead.status === 200 || result_hubspot_lead.status === 200) {
          setsuccessMsg('Please check your email to download your file.')
          setDisable(false)
          setIsLoading(false)
          resetForm()
        } else {
          setDisable(false)
          setIsLoading(false)
          setsuccessMsg('Some error occured else')
        }
      } catch (err) {
        setDisable(false)
        setIsLoading(false)
        setsuccessMsg('Some error occured catch')
      }
    }
  })

  const { errors, touched } = formikLogin

  return (
    <>
      <Form className='contact-us-form'>
        <Row md={2} xs={1}>
          {/* <Form.Group as={Col} className='mb-4'>
            <Form.Label>
              First Name <em>*</em>
            </Form.Label>
            <Form.Control
              type='text'
              name='first_name'
              value={formikLogin.values.first_name}
              onChange={formikLogin.handleChange}
              onBlur={formikLogin.handleBlur}
              placeholder='Enter your first name'
            />
            <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
              {errors.first_name && touched.first_name
                ? errors.first_name
                : null}
            </p>
          </Form.Group>
          <Form.Group as={Col} className='mb-4'>
            <Form.Label>
              Last Name <em>*</em>
            </Form.Label>
            <Form.Control
              type='text'
              name='last_name'
              value={formikLogin.values.last_name}
              onChange={formikLogin.handleChange}
              onBlur={formikLogin.handleBlur}
              placeholder='Enter your last name'
            />
            <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
              {errors.last_name && touched.last_name ? errors.last_name : null}
            </p>
          </Form.Group> */}
          <Form.Group as={Col} className={errors.full_name && touched.full_name ? "mb-3 was-validated" : "mb-3"} >
            <Form.Label>
              Name <em className='text-danger'>*</em>
            </Form.Label>
            <Form.Control
              type='text'
              name='full_name'
              value={formikLogin.values.full_name}
              onChange={formikLogin.handleChange}
              onBlur={formikLogin.handleBlur}
              placeholder='Enter your name'
              required
            />
            {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
              {errors.full_name && touched.full_name
                ? errors.full_name
                : null}
            </p> */}
          </Form.Group>
          <Form.Group as={Col} className={errors.phone_no && touched.phone_no ? "mb-3 was-validated" : "mb-3"} >
            <Form.Label>
              Phone number <em className='text-danger'>*</em>
            </Form.Label>
            <PhoneInput
              inputProps={{
                name: 'phone_no',
                required: true,
              }}
              inputClass='form-control-phone form-control-lg'
              containerClass='country-phone'
              onChange={e =>
                formikLogin.setFieldValue('phone_no', e)
              }
              onBlur={formikLogin.handleBlur}
              value={formikLogin.values.phone_no}
              country={userCountry ? userCountry : 'us'}
              countryCodeEditable={false}
              enableSearch={true}
              disableSearchIcon={true}

            />
            {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                          {errors.phone_no && touched.phone_no
                            ? errors.phone_no
                            : null}
                        </p> */}
          </Form.Group>
          <Form.Group as={Col} className={errors.company_name && touched.company_name ? "mb-3 was-validated" : "mb-3"}>
            <Form.Label>
              Company Name <em className='text-danger'>*</em>
            </Form.Label>
            <Form.Control
              type='text'
              name='company_name'
              value={formikLogin.values.company_name}
              onChange={formikLogin.handleChange}
              onBlur={formikLogin.handleBlur}
              placeholder='Enter your company name'
              required
            />
            {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
              {errors.company_name && touched.company_name
                ? errors.company_name
                : null}
            </p> */}
          </Form.Group>
          <Form.Group as={Col} className={errors.email && touched.email ? "mb-3 was-validated" : "mb-3"}>
            <Form.Label>
              Your Email <em className='text-danger'>*</em>
            </Form.Label>
            <Form.Control
              type='email'
              name='email'
              value={formikLogin.values.email}
              onChange={formikLogin.handleChange}
              onBlur={formikLogin.handleBlur}
              isInvalid={touched.email && errors.email}
              placeholder='Enter your email address'
              required
            />
            {touched.email && errors.email && formikLogin.values.email && (
                                    <p className='form-text text-danger mt-2 mb-0 font-size-14'>
                                        Please use a corporate email address
                                    </p>
                                )}
            {/* <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
              {errors.email && touched.email ? errors.email : null}
            </p> */}
          </Form.Group>
          {

            personalized_consultation ?
              <Form.Group as={Col} md={12} className="mb-3">
                <Form.Label>
                  Would you like one of our fintech experts to contact you for a personalized consultation? <em className='text-danger'>*</em>
                </Form.Label>
                <div className='d-flex align-items-center'>
                  <Form.Check
                    className="me-5"
                    type="radio"
                    label="Yes"
                    id="option1"
                    name="personalized_consultation"
                    value="Yes"
                    checked={formikLogin.values.personalized_consultation === "Yes"}
                    onChange={formikLogin.handleChange}
                    onBlur={formikLogin.handleBlur}
                  />
                  <Form.Check
                    type="radio"
                    label="No"
                    id="option2"
                    name="personalized_consultation"
                    value="No"
                    checked={formikLogin.values.personalized_consultation === "No"}
                    onChange={formikLogin.handleChange}
                    onBlur={formikLogin.handleBlur}
                  />
                </div>
                <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                  {errors.personalized_consultation && touched.personalized_consultation ? errors.personalized_consultation : null}
                </p>
              </Form.Group> :
              null
          }
          {

            discuss_detail ?
              <Form.Group as={Col} md={12} className="mb-3">
                <Form.Label>
                  I would like to discuss <em className='text-danger'>*</em>
                </Form.Label>

                <Form.Check
                  className="me-5"
                  type="radio"
                  label="Mobile Money"
                  id="option3"
                  name="discuss_detail"
                  value="Mobile Money"
                  checked={formikLogin.values.discuss_detail === "Mobile Money"}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />
                <Form.Check
                  type="radio"
                  label="Cross-Border Remittance"
                  id="option4"
                  name="discuss_detail"
                  value="Cross-Border Remittance"
                  checked={formikLogin.values.discuss_detail === "Cross-Border Remittance"}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />
                <Form.Check
                  type="radio"
                  label="Ongoing Fintech Project"
                  id="option5"
                  name="discuss_detail"
                  value="Ongoing Fintech Project"
                  checked={formikLogin.values.discuss_detail === "Ongoing Fintech Project"}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />
                <Form.Check
                  type="radio"
                  label="Partnership Opportunity"
                  id="option6"
                  name="discuss_detail"
                  value="Partnership Opportunity"
                  checked={formikLogin.values.discuss_detail === "Partnership Opportunity"}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />
                <Form.Check
                  type="radio"
                  label="Other"
                  id="option7"
                  name="discuss_detail"
                  value="Other"
                  checked={formikLogin.values.discuss_detail === "Other"}
                  onChange={formikLogin.handleChange}
                  onBlur={formikLogin.handleBlur}
                />
                <p className='form-text text-danger mt-2 mb-0 font-size-14 text-uppercase0'>
                  {errors.discuss_detail && touched.discuss_detail ? errors.discuss_detail : null}
                </p>
              </Form.Group> :
              null
          }
          <Form.Control type="hidden" name="form_name" value={formikLogin.values.form_name} />
          <Form.Control type="hidden" name="pdf_url" value={formikLogin.values.pdf_url} />
        </Row>
        <div className='form-action text-end'>
          <Button
            type='button'
            onClick={() => formikLogin.handleSubmit()}
            disabled={disable}
            variant=''
            size='lg'
            className='btn-primary-theme mt-2'
          >
            <span>{isLoading ? 'Sending...' : buttonLabel}</span>
          </Button>
        </div>
        {successMsg ? (
          <div className='alert alert-success mt-4'> {successMsg} </div>
        ) : null}
      </Form>
    </>
  )
}

export default WhitepaperForm
